import ReactTooltip from 'react-tooltip'
import { MdInfoOutline } from 'react-icons/md'

import { Container, Label } from './styles'

export default function Tooltip ({
  id,
  message,
  icon = null,
  place = 'top',
  tooltipRadius = '10',
  style = {},
  labelStyle = {}
}) {
  return (
    <Container data-for={id} data-tip style={style}>
      {icon || <MdInfoOutline size={16} color='#FFC100'/>}
      <ReactTooltip
        id={id}
        effect='solid'
        place={place}
        backgroundColor='#252525'
        tooltipRadius={tooltipRadius}
      >
        <Label style={labelStyle}>
          {message}
        </Label>
      </ReactTooltip>
    </Container>
  )
}
